import { useTranslation } from 'react-i18next';
import { useSelectedSpacesEditorStyles } from './SelectedSpacesEditor.styles';

export interface CapacitySummaryProps {
  spaceCount: number;
  totalCapacity: number;
  attendeeCount: number;
}

export const CapacitySummary = ({
  spaceCount,
  totalCapacity,
  attendeeCount,
}: CapacitySummaryProps) => {
  const styles = useSelectedSpacesEditorStyles();
  const { t } = useTranslation('planner');

  if (spaceCount === 0) return null;

  const isSufficient = totalCapacity >= attendeeCount;

  return (
    <div className={styles.summary} data-testid="capacity-summary">
      <div className={styles.summaryLine}>
        {t('reviewPanel.spacesSelectedSummary', {
          count: spaceCount,
          capacity: totalCapacity,
        })}
      </div>
      {!isSufficient && (
        <div
          className={styles.validationWarning}
          role="status"
          data-testid="capacity-validation"
        >
          {t('reviewPanel.attendeeCapacityInsufficient', {
            attendees: attendeeCount,
            capacity: totalCapacity,
          })}
        </div>
      )}
    </div>
  );
};

CapacitySummary.displayName = 'CapacitySummary';
